<template>
  <div class="exam-status">
    <div class="status-card pending"
         @click="handleJump('/waitExam')">
      <div class="status-title">待参加考试</div>
      <div class="status-count">{{awaitCount}}</div>
    </div>
    <div class="status-card completed"
         @click="handleJump('/alreadyExam')">
      <div class="status-title">已参加考试</div>
      <div class="status-count">{{finishCount}}</div>
    </div>
  </div>
</template>

<script>
import { examStatistics } from "@/api/index.js";
export default {
  name: 'ExamStatus',
  data() {
    return {
      awaitCount: '0',
      finishCount: '0',
    }
  },
  created() {
    this.getExamStatistics();
  },
  methods: {
    async getExamStatistics() {
      const { code, data } = await examStatistics();
      if (code == 200) {
        this.awaitCount = data.awaitCount || '0';
        this.finishCount = data.finishCount || '0';
      }
    },
    handleJump(path) {
      this.$router.push({ path })
    }
  },
}
</script>

<style lang="less" scoped>
// 组件2：考试状态样式
.exam-status {
  display: flex;
  gap: 12px;
  padding: 0 16px 20px;

  .status-card {
    flex: 1;
    background: white;
    border-radius: 12px;
    padding: 16px;
    text-align: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    .status-title {
      font-size: 14px;
      color: #666;
      margin-bottom: 8px;
    }

    .status-count {
      font-size: 24px;
      font-weight: bold;
      color: #333;
    }
  }
}
</style>